import React from "react";
import {withContext} from "with-context";

export const ShopProductContext = React.createContext({});
export const withShopProductContext = withContext(ShopProductContext, "product");
